import React, { createContext, useContext, useMemo } from 'react';

enum UserLoginStatus {
  LOGGED = 'LOGGED',
  NOT_LOGGED = 'NOT_LOGGED',
  REMEMBERED = 'REMEMBERED',
  LOADING = 'LOADING',
}

enum MembershipStatus {
  ACTIVATED = 'ACTIVATED',
  PENDING_TO_COLLECT = 'PENDING_TO_COLLECT',
  PENDING_TO_ACTIVATE = 'PENDING_TO_ACTIVATE',
  EXPIRED = 'EXPIRED',
  DEACTIVATED = 'DEACTIVATED',
}

type LoginContextType = {
  user: {
    status: UserLoginStatus;
    membership: {
      status: MembershipStatus;
    };
  };
};

const LoginContext = createContext<LoginContextType>({
  user: {
    status: UserLoginStatus.NOT_LOGGED,
    membership: {
      status: MembershipStatus.DEACTIVATED,
    },
  },
});

export const LoginProvider = ({ children, loginProps }) => {
  const value = useMemo(
    () => ({
      ...loginProps,
    }),
    [loginProps]
  );

  return (
    <LoginContext.Provider value={value}>{children}</LoginContext.Provider>
  );
};

export const useLogin = () => {
  const data = useContext(LoginContext);
  const isPrime = useMemo(
    () => data?.user?.membership?.status === MembershipStatus.ACTIVATED,
    [data?.user?.membership?.status]
  );

  return {
    ...data,
    isPrime,
  };
};
